<script lang="ts" setup>
const props = defineProps<{
  completed: boolean[],
  currentIndex: number,
  disableItemsAfterCurrent?: boolean
}>()
const emit = defineEmits<{ (e: 'click', index: number): void }>()
</script>

<template>
  <div
    class="flex space-x-2"
  >
    <button
      type="button"
      v-for="(_, index) in props.completed.length"
      :id="`carousel-marker-${index}`"
      :key="`marker-${index}`"
      @click="emit('click', index)"
      class="w-4 h-4 rounded-full transition-colors duration-300 cursor-pointer disabled:cursor-not-allowed disabled:bg-gray-200"
      :class="{
        'bg-(--brand-primary)': props.currentIndex === index,
        'bg-(--brand-progress) hover:bg-(--brand-tertiary)': props.currentIndex !== index,
      }"
      :disabled="!completed[index]"
      :aria-label="`Slide to ${index + 1}`"
      :aria-current="props.currentIndex === index ? 'step' : undefined"
    />
  </div>
</template>
